import React from 'react';

import { LayoutComponent } from '@neptune/entity-common-domain';
import {
  EntityChanges,
  EntityWithPermissions,
  getEntityAttribute,
} from '@neptune/shared/entity-domain';
import { useProjectTagsDataSource } from '@neptune/shared/tags-business-logic';
import { useTagColors } from '@neptune/tags-business-logic';

import { KnownAttributes } from 'domain/experiment/attribute';

type EntityPropertiesContainerProps = {
  entityWithPermissions: EntityWithPermissions;
  LayoutComponent: LayoutComponent;
  onEntityChange: (entityUpdates: Partial<EntityChanges>) => Promise<void>;
};

export const EntityPropertiesContainer: React.FC<EntityPropertiesContainerProps> = ({
  entityWithPermissions,
  LayoutComponent,
  onEntityChange,
}) => {
  const tagAttribute = getEntityAttribute(entityWithPermissions, KnownAttributes.Tags, 'stringSet');
  const projectTagsDataSource = useProjectTagsDataSource({
    types: ['run'],
    projectIdentifier: entityWithPermissions.projectId,
    disabledTags: tagAttribute?.values,
  });

  const groupTagAttribute = getEntityAttribute(
    entityWithPermissions,
    KnownAttributes.GroupTags,
    'stringSet',
  );
  const projectGroupTagsDataSource = useProjectTagsDataSource({
    types: ['run'],
    projectIdentifier: entityWithPermissions.projectId,
    disabledTags: groupTagAttribute?.values,
  });

  const { getColorForTag } = useTagColors();

  return entityWithPermissions ? (
    <LayoutComponent
      colorGetter={getColorForTag}
      entity={entityWithPermissions}
      onEntityChange={onEntityChange}
      groupTagsDataSource={projectGroupTagsDataSource}
      tagsDataSource={projectTagsDataSource}
    />
  ) : null;
};
